import React, { useEffect, useState } from 'react';
import './SliderTask.scss';
import SliderTaskService from './SliderTaskService';
import { useDispatch, useSelector } from 'react-redux';
import useSlider from '../../../shared/components/Slider/useSlider';
import { useConfirmationModalContext } from '../../../shared/components/ModalConfirmationContext';
import CustomerSliderContainerService from '../CustomerSliderContainerService';
import { RootState } from '../../../shared/store';
import { Button, Column, DateTimePicker, Label, Row, Select } from '../../../components';
import { TaskScreenLables } from "../../../shared/util/label";
import * as lables from "../../../shared/util/label";
import { cleareTabsInputs, SliderDataAction, updateSliderCurrentTab, updateSliderData } from '../CustomerSliderContext';
import { toast } from 'react-toastify';
import Logger from '../../../shared/services/Logger';
import CustomerTaskViewService from '../../customer-tasks/CustomerTasksViewService';
import TextFieldWithLabelInline from '../../../shared/components/input/TextFieldWithLabelInline';
import DropDownWithLabelInline from '../../../shared/components/input/DropDownWithLabelInline';
import { updateLookupData } from '../../customer-slice/Customer-lookup-slice';
import { CUSTOMER_NOT_FOUND, CustomerScreenTabs, CustomerTaskConstants, SlicerLookUpConstant } from '../../../shared/util/constant';
import { SelectOption } from '../../../shared/components/input';
import TextInputWithLabelInline from '../../../shared/components/input/TextInputWithLabelInline';
import CustomerActivityService from '../../customer-activity/CustomerActivityService';
import { AppEvenType, notifyAppEvent } from '../../../shared/store/component-notification/ComponentNotification';
import { FloatingLabel, Form, InputGroup } from 'react-bootstrap';
import { CustomerTaskDto } from '../../model/CustomerTaskDto';
import { LookupDetailConstants } from "../../../shared/util/LookupDetailConstants";
import { cl } from '@fullcalendar/core/internal-common';

export interface ISliderTask  {
    customerId? : string,
    navigateTo : (path : string) => void
}

const SlidterTask : React.FunctionComponent<ISliderTask>  = (props) => {
    const sliderTaskService = new SliderTaskService();
    const customerSliderContainerService = new CustomerSliderContainerService();
    const customerTaskService = new CustomerTaskViewService();
    const customerActivityService = new CustomerActivityService();

    const dispatch = useDispatch();
    const slider = useSlider();
    const modalContext = useConfirmationModalContext();

    let customerInfo = useSelector((state: RootState) => state?.customerSlice);
    let customerSliderState = useSelector((state: RootState) => state?.CustomerSliderState);

    const customerTask = customerSliderState.taskPage.customerTask;
    const formValidation = customerSliderState.taskPage.formValidation;
    const policiesForSelect = [...customerSliderState.taskPage.policiesForSelect];

    const taskPriorities = useSelector((state: RootState) => state?.LookupState.taskPriorityList);
    const taskTypes = useSelector((state: RootState) => state?.LookupState.activityTypeList);
    const taskStatuses = useSelector((state: RootState) => state?.LookupState.taskStatusList);
    const empList = useSelector((state: RootState) => state?.LookupState.employeeList);
    const companyList = useSelector((state: RootState) => state?.LookupState.companyList);

    const [taskPriorityList, setTaskPriorityList] = useState<SelectOption[]>([]);
    const [taskStatusList, setTaskStatusList] = useState<SelectOption[]>([]);
    const [taskTypeList, setTaskTypeList] = useState<SelectOption[]>([]);
    const [employeeList, setEmployeeList] = useState<SelectOption[]>([]);
    const [companiesList, setCompanyList] = useState<SelectOption[]>([]);
    const [isPolicyOptional, setIsPolicyOptional] = useState(false);
     const userDetails = useSelector((state: any) => state.userContextSlice);

    useEffect(() => {
        initializeComponent();
    }, []);

    const initializeComponent =  async () => {

        let tskStatusList = [];
        let tskPriorityList = [];
        let tskTaskTypeList = [];
        let emplSelectList = [];
        let compSelectList = [];

        if (!taskPriorities || taskPriorities.length == 0) {
            tskPriorityList = await customerTaskService.getTaskPriorityList();
            dispatch(updateLookupData({data : tskPriorityList, type : SlicerLookUpConstant.TASK_PRIORITY}));
        }
        else {
            tskPriorityList = [...taskPriorities];
        }

        if (!taskTypes || taskTypes.length == 0) {
            tskTaskTypeList = await customerTaskService.getTaskTypeList();
            dispatch(updateLookupData({data : tskTaskTypeList, type : SlicerLookUpConstant.ACTIVITY_TYPE}));
        }
        else {
            tskTaskTypeList = [...taskTypes];
        }

        if (!taskStatuses || taskStatuses.length == 0) {
            tskStatusList = await customerTaskService.getTaskStatusList();
            dispatch(updateLookupData({data : tskStatusList, type : SlicerLookUpConstant.TASK_STATUS}));
        }
        else {
            tskStatusList = [...taskStatuses];
        }

        if (!empList || empList.length == 0) {
            emplSelectList = await customerTaskService.getEmployeeList();
            dispatch(updateLookupData({data : emplSelectList, type : SlicerLookUpConstant.EMPLOYEE_LIST}));
        }
        else {
            emplSelectList = [...empList];
        }

        if (!companyList || companyList.length == 0) {
            compSelectList = await customerTaskService.getCompanyList();
            dispatch(updateLookupData({data : compSelectList, type : SlicerLookUpConstant.COMPANY_LIST}));
        }
        else {
            compSelectList = [...companyList];
        }

        setTaskPriorityList(tskPriorityList);
        setTaskStatusList(tskStatusList);
        setTaskTypeList(tskTaskTypeList);
        setEmployeeList(emplSelectList);
        setCompanyList(compSelectList);
      

      if (!policiesForSelect || policiesForSelect.length == 0) {
        let custPolicyData = await customerActivityService.getPoliciesForCustomer(customerInfo?.customer?.id);
        if (!custPolicyData || custPolicyData.length == 0) {
          setIsPolicyOptional(true);

        }
        else {
          setIsPolicyOptional(false);
        }

        // Always initialize the customerTask fields when opening the slider
         // Find the default policy and its associated company
        const defaultPolicy = custPolicyData.length === 1 ? custPolicyData[0] : null;
        const defaultCompanyId = defaultPolicy?.companyId || null;

        let updatedTaskData = {
            ...customerTask,
            custId: customerInfo?.customer?.id,
            dueDate: customerTask.dueDate || new Date(),
            polId: customerTask.polId || (defaultPolicy ? defaultPolicy.value : null),
            companyId: customerTask.companyId || defaultCompanyId, // Set the default companyId
            toUserId: customerTask.toUserId || userDetails?.userContext?.id, // Set assignedTo as current logged-in user
            priorityId: customerTask.priorityId || LookupDetailConstants.CUSTOMER_TASK_PRIORITY.LOW, // Set priority as "Low"
            statusId: customerTask.statusId || LookupDetailConstants.CUSTOMER_TASK_STATUS.INCOMPLETE, // Set status as "Incomplete"
        };
        saveTaskInStore(updatedTaskData);

        dispatch(updateSliderData({ type : SliderDataAction.TaskPolicyListUpdate, data : custPolicyData}));
      } else {
        // Find the default policy and its associated company
        const defaultPolicy = policiesForSelect.length === 1 ? policiesForSelect[0] : null;
        const defaultCompanyId = defaultPolicy?.companyId || null;
        let updatedTaskData = {
            ...customerTask,
            custId: customerTask.custId || customerInfo?.customer?.id,
            dueDate: customerTask.dueDate || new Date(),
            polId: customerTask.polId || (defaultPolicy ? defaultPolicy.value : null),
            companyId: customerTask.companyId || defaultCompanyId, // Set the default companyId
            toUserId: customerTask.toUserId || userDetails?.userContext?.id, // Set assignedTo as current logged-in user
            priorityId: customerTask.priorityId || LookupDetailConstants.CUSTOMER_TASK_PRIORITY.LOW, // Set priority as "Low"
            statusId: customerTask.statusId || LookupDetailConstants.CUSTOMER_TASK_STATUS.INCOMPLETE, // Set status as "Incomplete"
        };
        // Only update if any field is missing
        if (!customerTask.custId || !customerTask.dueDate || !customerTask.polId) {
          saveTaskInStore(updatedTaskData);
        }
      }
    }

    const saveTaskInStore = (customerTask : CustomerTaskDto) => {
        dispatch(updateSliderData({ type : SliderDataAction.TaskUpdate, data : customerTask}));
    }

    const onCancelClick = async () => {
        dispatch(cleareTabsInputs());
        dispatch(updateSliderData({ type : SliderDataAction.TaskUpdate, data : {...customerTask,description : '',claimId : '',ccUserId : '', taskTypeId : ''}}));

    }
    
    const onSaveClick = async () => {
        try {

            let validationError = sliderTaskService.validateSliderTask(customerTask, isPolicyOptional);
            dispatch(updateSliderData({ type : SliderDataAction.TaskFormValidationUpdate, data : validationError}));

            if (Object.keys(validationError).length > 0) {
                toast.warn(CustomerTaskConstants.FORM_VALIDATION_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }
            
            let taskPolicy = policiesForSelect?.find(item => item.value == customerTask.polId);
            let taskRequestDto = sliderTaskService.getTaskRequestDto(customerTask, taskPolicy?.originalData?.polEffDate);

            let newTask = await sliderTaskService.createTask(taskRequestDto);
            toast.success(CustomerTaskConstants.TASK_SAVED_SUCCESSFULLY);
            dispatch(notifyAppEvent({ eventType : AppEvenType.NewTaskCreated, eventData : newTask}));
            dispatch(cleareTabsInputs());
            dispatch(updateSliderCurrentTab(CustomerScreenTabs.tasks.key));
            const defaultPolicy = policiesForSelect.length === 1 ? policiesForSelect[0] : null;
            const defaultCompanyId = defaultPolicy?.companyId || null;
            saveTaskInStore({ dueDate : new Date(), custId : customerInfo?.customer?.id,
              polId: (defaultPolicy ? defaultPolicy.value : null),
              companyId: defaultCompanyId, // Set the default companyId
              toUserId: customerTask.toUserId || userDetails?.userContext?.id, // Set assignedTo as current logged-in user
              priorityId: customerTask.priorityId || LookupDetailConstants.CUSTOMER_TASK_PRIORITY.LOW, // Set priority as "Low"
              statusId: customerTask.statusId || LookupDetailConstants.CUSTOMER_TASK_STATUS.INCOMPLETE, // Set status as "Incomplete"
              description: '',
              claimId: '',
            });
            if (!slider.isSliderPinned) {
                slider.hideSlider();
            }
        }
        catch (ex) {
            if ((ex.status == 422 && ex.data?.error == CustomerTaskConstants.CUSTOMER_DELETED) || ex.status == 404) {
                toast.error(CUSTOMER_NOT_FOUND);
                props.navigateTo('/customer/customerfilter');
                return;
            }
            toast.error(CustomerTaskConstants.ERROR_WHILE_INITIALIZING_TASK_SLIDER_COMPONENT);
            Logger.logError(CustomerTaskConstants.ERROR_WHILE_INITIALIZING_TASK_SLIDER_COMPONENT, ex);
        }
    }

    const onEntityFieldChange = (propName: string, value: string | Date|boolean) => {
        let valueToUpdate = value;

        // Don't allow to remove customer id.
        if (propName == 'custId' && !value) {
            valueToUpdate = customerInfo?.customer?.id;
        }

        let updatedTaskData = {
            ...customerTask,
            [propName]: valueToUpdate,
          };
        dispatch(updateSliderData({ type : SliderDataAction.TaskUpdate, data : updatedTaskData}));
    }

    let lableSize = 4;
    let inputSize = 8;
    const isEditable = true;

    let mainContent = <>
         <Row>
            <Column lg={12} md={12} className="">
                <span className="sld-task-section-header">{TaskScreenLables.newTask}</span>
            </Column>
        </Row>

        <Row>
            <Column lg={12} md={12}>
            <FloatingLabel
      controlId="taskDescription"
      label={
        <>
          {TaskScreenLables.description}
          <span className="text-danger">*</span>
        </>
      }
    >
      <Form.Control
        as="textarea"
        name="taskDescription"
        placeholder={TaskScreenLables.description}
        value={customerTask.description}
        onChange={(event) => onEntityFieldChange('description', event.currentTarget.value)}
        disabled={!isEditable}
        tabIndex={1}
        maxLength={1000}
        isInvalid={formValidation['description']?.isValid == false}
        className='texbox-input sld-task-descr-input mb-3'
      />
      {formValidation['description']?.isValid == false && (
        <Form.Control.Feedback type="invalid">
          {formValidation['description']?.warningText}
        </Form.Control.Feedback>
      )}
    </FloatingLabel>
            </Column>
        </Row>
      <Row>
        <Column lg={12} md={12}>
          <Select
            id='ddToUserId'
            label={TaskScreenLables.assignedTo}
            options={employeeList ?? []}
            defaultSelected={employeeList?.filter(({ value }) =>
              String(value) === String(customerTask.toUserId)
            ) ?? []}
            onChange={(values) => {
              const selectedValue = values?.[0];
              if (selectedValue) {
                onEntityFieldChange('toUserId', selectedValue as string)
              }
            }}
            isRequired={true}
            placeholder={TaskScreenLables.pleaseSelect}
            multiple={false}
            isInvalid={formValidation['toUserId']?.isValid == false}
            invalidWarning={formValidation['toUserId']?.warningText}
            tabIndex={3}
            showAsFloatingLabel={true}
            className='mb-3'
          />
            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12}>

    
      <DateTimePicker
                            dateFormatCalendar="LLLL yyyy"
                            dropdownMode="scroll"
                            className='mb-3'
                            selected={customerTask.dueDate}
                            tabIndex={2}
                            isRequired={true}
                            prependLabelText={TaskScreenLables.dueDate}
                            showAppendIcon={true}
                            onChange={(date) => onEntityFieldChange('dueDate', date)}
                            isInvalid={formValidation['dueDate']?.isValid == false}
                            invalidWarning={formValidation['dueDate']?.warningText}
                            invalidLableClass="lable-error sld-task-input-error"
                            errorLableDivClassName='sld-task-action-select-div'/>

      {formValidation['dueDate']?.isValid === false && (
        <Form.Control.Feedback type="invalid">
          {formValidation['dueDate']?.warningText}
        </Form.Control.Feedback>
      )}

                
            </Column>
        </Row>

<Row>
  <Column lg={12} md={12}>
    <Select
      id='ddTaskPriority'
      label={TaskScreenLables.priority}
      options={taskPriorityList}
      defaultSelected={taskPriorityList?.filter(({ value }) => 
        String(value) === String(customerTask.priorityId)
      ) ?? []}
      onChange={(values) => {
        onEntityFieldChange('priorityId', values[0] as string)
      }}
      isRequired={true}
      placeholder={TaskScreenLables.pleaseSelect}
      multiple={false}
      isInvalid={formValidation['priorityId']?.isValid == false}
      invalidWarning={formValidation['priorityId']?.warningText}
      tabIndex={1}
      showAsFloatingLabel={true}
      className='mb-3'
    />
  </Column>
</Row>

<Row>
  <Column lg={12} md={12}>
    <Select
      id='ddTaskStatus'
      label={TaskScreenLables.status}
      options={taskStatusList}
      defaultSelected={taskStatusList?.filter(({ value }) => 
        String(value) === String(customerTask.statusId)
      ) ?? []}
      onChange={(values) => {
        onEntityFieldChange('statusId', values[0] as string)
      }}
      isRequired={true}
      placeholder={TaskScreenLables.pleaseSelect}
      multiple={false}
      isInvalid={formValidation['statusId']?.isValid == false}
      invalidWarning={formValidation['statusId']?.warningText}
      tabIndex={1}
      showAsFloatingLabel={true}
      className='mb-3'
    />
  </Column>
</Row>

        <Row>
            <Column lg={12} md={12}>
            <Select
  id='taskType'
  label={TaskScreenLables.taskType}
  options={taskTypeList}
  defaultSelected={taskTypeList?.filter(({ value }) => value === customerTask.taskTypeId)}
  onChange={
      (values) => {
          onEntityFieldChange('taskTypeId', values[0] as string)
      }
  }  isRequired={true}
  placeholder={TaskScreenLables.pleaseSelect}
  multiple={false}
  isInvalid={formValidation['taskTypeId']?.isValid == false}
  invalidWarning={formValidation['taskTypeId']?.warningText}
  tabIndex={2}
  showAsFloatingLabel={true}
  className='mb-3'
/>
                
            </Column>
        </Row>

        

        <Row>
            <Column lg={12} md={12}>
            <Select
  id='ddCCUserId'
  label={TaskScreenLables.cc}
  options={employeeList ?? []}
  defaultSelected={employeeList?.filter(({ value }) => 
    String(value) === String(customerTask.ccUserId)
  ) ?? []}
  onChange={(values) => {
    onEntityFieldChange('ccUserId', values[0] as string)
  }}
  isRequired={false}
  placeholder={TaskScreenLables.pleaseSelect}
  multiple={false}
  isInvalid={formValidation['ccUserId']?.isValid == false}
  invalidWarning={formValidation['ccUserId']?.warningText}
  tabIndex={1}
  showAsFloatingLabel={true}
  className='mb-3'
/>
            </Column>
        </Row>
       

        <Row>
            <Column lg={12} md={12}>
          <Select
            key={customerTask.polId} // This forces re-render when polId changes
            id='ddSldTaskPolicy'
            label={TaskScreenLables.policyNumber}
            options={policiesForSelect ?? []}
            defaultSelected={
              policiesForSelect?.filter(({ value }) =>
                String(value) === String(customerTask.polId)
              ) ?? []
            }
            onChange={(values) => {
              const selectedPolicyId = values[0] as string;

              const selectedPolicy = policiesForSelect.find(
                (policy) => policy.value == selectedPolicyId
              );

              const updatedTaskData = {
                ...customerTask,
                polId: selectedPolicyId,
                ...(selectedPolicy?.companyId && { companyId: selectedPolicy.companyId }),
              };

              dispatch(updateSliderData({
                type: SliderDataAction.TaskUpdate,
                data: updatedTaskData,
              }));
            }}
            isRequired={!isPolicyOptional}
            placeholder={TaskScreenLables.pleaseSelect}
            multiple={false}
            isInvalid={!isPolicyOptional && formValidation['polId']?.isValid == false}
            invalidWarning={!isPolicyOptional && formValidation['polId']?.warningText}
            tabIndex={6}
            showAsFloatingLabel={true}
            className='mb-3'
            sortOptions={false}
          />
            </Column>
        </Row>

        <Row>
            <Column lg={12} md={12}>
            <FloatingLabel
      controlId="ddTskSldClaimNumber"
      label={TaskScreenLables.claimNumber}
    >
      <Form.Control
        type="text"
        name="ddTskSldClaimNumber"
        placeholder={TaskScreenLables.claimNumber}
        value={customerTask.claimId}
        onChange={(event) => onEntityFieldChange('claimId', event.currentTarget.value)}
        disabled={!isEditable}
        tabIndex={1}
        maxLength={60}
        className='texbox-input mb-3'
      />
    </FloatingLabel>
            </Column>
        </Row>

        <Row>
            <Column lg={12} md={12}>
          <Select
            id='ddlTaskCustomerCompany'
            label={TaskScreenLables.company}
            options={companiesList ?? []}
            defaultSelected={
              companiesList?.filter(({ value }) =>
                String(value) === String(customerTask.companyId)
              ) ?? []
            }
            onChange={(values) => {
              onEntityFieldChange('companyId', values[0] as string); // Update the companyId
            }}
            isRequired={true}
            placeholder={TaskScreenLables.pleaseSelect}
            multiple={false}
            isInvalid={formValidation['customerCompanyId']?.isValid == false}
            invalidWarning={formValidation['customerCompanyId']?.warningText}
            tabIndex={5}
            showAsFloatingLabel={true}
            className='mb-3'
          />
                
            </Column>
        </Row>

        {/* Action Row */}
        <Row className="mb-2 sld-task-action-row">
            <Column lg={6} md={6} className="sld-task-col">
                <Button
                    className='btn btn-outline-tertiary sld-action-btn-base'
                    key="btnSliderTaskCancel"
                    onClick={() => onCancelClick()}
                    id="btnSliderTaskCancel"
                    color='primary'
                    outlined={true}
                >{lables.StandardSearchLable.CLEAR.toLocaleUpperCase()}
                </Button>

            </Column>
            <Column lg={6} md={6} className="sld-task-col text-right">
                <Button
                    className='sld-action-btn-base'
                    key="btnSliderTaskSave"
                    onClick={() => onSaveClick()}
                    tabIndex={21}
                    id="btnSliderTaskSave"
                    color='primary'
                >{lables.SAVE.toLocaleUpperCase()}
                </Button>
            </Column>
        </Row>
    </>;

    return (
        <div className='slider-tab-content-main-div'>
            {mainContent}
        </div>
    );
}

export default SlidterTask;